import React from 'react';
import { motion } from 'framer-motion';
export function NoBrainSection() {
  return <section className="relative py-20 md:py-28 bg-[#FAF7F2] text-[#0A0A0A]" data-id="element-175">
      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#0A0A0A] to-transparent pointer-events-none" data-id="element-176"></div>
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0A0A0A] to-transparent pointer-events-none" data-id="element-177"></div>

      <div className="max-w-3xl mx-auto px-4" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-179">
          <p className="text-[#C5A55A] text-sm uppercase tracking-widest mb-4" data-id="element-180">
            🧠 No brain
          </p>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#0A0A0A]" data-id="element-181">
            Piénsalo sin emoción.
          </h2>
        </motion.div>

        <div className="space-y-8" data-id="element-182">
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-183">
            <p className="text-lg md:text-xl text-[#333] font-light" data-id="element-184">
              ¿Cuánto cuesta una terapia de pareja?
            </p>
            <p className="text-xl md:text-2xl text-[#0A0A0A] font-bold mt-1" data-id="element-185">
              $100 por sesión promedio.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-186">
            <p className="text-xl md:text-2xl text-[#0A0A0A] font-serif italic" data-id="element-187">
              ¿Y cuánto cuesta perder la conexión?
            </p>
          </motion.div>

          <div className="w-full h-px bg-[#0A0A0A]/10 my-4" data-id="element-188"></div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-189">
            <p className="text-2xl md:text-3xl font-bold text-[#0A0A0A]" data-id="element-190">
              18 Métodos cuesta <span className="text-[#B91C1C]" data-id="element-191">$10</span>.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="space-y-2" data-id="element-192">
            <p className="text-lg md:text-xl text-[#333] font-light" data-id="element-193">
              Es menos que una cena. Pero puede cambiar el clima de tu relación.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} data-id="element-194">
            <p className="text-lg md:text-xl text-[#0A0A0A] font-medium" data-id="element-195">
              No necesitas pensarlo semanas. Necesitas actuar antes de que el
              daño sea mayor.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}